<div class="d-flex flex-wrap" [smooth-in]="vouchers">
  <ng-container *ngFor="let voucher of vouchers">
    <button class="btn btn-border btn-card w-100" [ngClass]="voucher?.checked ? 'non-clickable' : ''"
            (click)="useItem(voucher)">
      <i class="fas" [ngClass]="voucher.checked ? 'fa-check' : 'fa-star'"
         [ngStyle]="{'color': !voucher.checked ? '#ffffff' : '#000000'}"></i>
      <span>{{voucher?.name}}</span>
    </button>
  </ng-container>
</div>